var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.action === "list",
                expression: "action ==='list'"
              }
            ],
            staticClass: "main-content"
          },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "3400",
                  reset: true,
                  "expand-adv": true,
                  "show-simple": false,
                  "custom-search-items": _vm.customSearchItems,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addHandler }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_NewTo")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.editHandler }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Edit")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.deleteHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_OrderDelete")) + " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "25000619",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "25000620",
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: ["edit", "add"].includes(_vm.action),
                expression: "['edit', 'add'].includes(action)"
              }
            ],
            staticClass: "main-content rule-config-page"
          },
          [
            _c(
              "el-form",
              { attrs: { "label-position": "left", "label-width": "70px" } },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_RuleRole") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: { filterable: "", clearable: "" },
                            on: {
                              change: function($event) {
                                return _vm.commissionRoleChange(true)
                              }
                            },
                            model: {
                              value: _vm.form.commissionRole,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "commissionRole", $$v)
                              },
                              expression: "form.commissionRole"
                            }
                          },
                          _vm._l(
                            _vm.SystemConstants.COMMISSION_ROLE_LIST,
                            function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }
                          ),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ApplicablePersonnel")
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "padding-left": "5px"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "240px" },
                              attrs: {
                                no: "commissionPersonnel",
                                multiple: true,
                                filterable: "",
                                "default-multiple-value":
                                  _vm.form.commissionPersonnelList,
                                "tag-value": "uuid",
                                "tag-name": "chineseName",
                                "filter-tag-names": ["chineseName"],
                                cache: false,
                                "static-options": _vm.officeRoleUser,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.commissionPersonnelList = p.value
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: { type: "primary", no: "showRole" },
                                on: { click: _vm.showRoleDialog }
                              },
                              [_vm._v(" " + _vm._s("...") + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "padding-left": "5px" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ApplicableScript")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            no: "applicableScriptUuid",
                            multiple: true,
                            filterable: "",
                            "default-multiple-value":
                              _vm.form.applicableScriptUuidList,
                            "tag-value": "uuid",
                            "tag-name": "scriptName",
                            "filter-tag-names": ["scriptName"],
                            cache: false,
                            "static-options": _vm.ruleConfigs,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.applicableScriptUuidList = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "20px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "inline-block" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { type: "primary", no: "testRun" },
                            on: { click: _vm.testRunHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_TestRun")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "25000701",
                    "grid-params": _vm.edit.gridParams,
                    "grid-options": _vm.edit.gridOptions,
                    "column-defs": _vm.edit.columnDefs,
                    "row-data": _vm.edit.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.edit, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.edit, "gridParams", $event)
                    },
                    gridReady: function(params) {
                      return (_vm.edit.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "20px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "inline-block" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { type: "primary", no: "1" },
                            on: { click: _vm.saveHandler }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Save")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { type: "primary", no: "1" },
                            on: {
                              click: function($event) {
                                return _vm.cancelHandler()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_Cancel")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm.showJobDialog.visible
        ? _c("show-job-dialog", {
            ref: "showJobDialog",
            attrs: {
              visible: _vm.showJobDialog.visible,
              jobs: _vm.showJobDialog.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.showJobDialog, "visible", $event)
              },
              close: function($event) {
                _vm.showJobDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.branchRoleSelectDialog.visible
        ? _c("branch-role-select-dialog", {
            ref: "branchRoleSelectDialog",
            attrs: {
              visible: _vm.branchRoleSelectDialog.visible,
              value: _vm.branchRoleSelectDialog.value,
              "row-data": _vm.branchRoleSelectDialog.rowData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.branchRoleSelectDialog, "visible", $event)
              },
              callback: _vm.selectDialogHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }